import {
  Text,
  Button,
  CircularProgress,
  CircularProgressLabel,
  VStack,
  useToast
} from "@chakra-ui/react";
import { useVoiceprintStore } from "../store";
import { useEffect, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import { BASE_URL } from "../constants/api";

// Animate continue speaking like Uber places order (fake transition)

// Circular progress bar voice fake animation

const CallStart = ({ progress, setProgress,callInitiated, accessToken,speech_interval }) => {
  const {
    currentStep,
    setCurrentStep,
    stream_uid,
    external_id,
    speech_duration,
    setSpeechDuration
  } = useVoiceprintStore();

  // useEffect(() => {
  //   console.log(speech_interval);
  //   if (speech_interval === null) {
  //     speech_interval = setInterval(() => {
  //       axios
  //         .get(`${BASE_URL}/stream/http/speech/${stream_uid}`)
  //         .then(res => {
  //           if (res.status === 200) {
  //             console.log(res.data);
  //             setProgress(res.data.speech_duration);
  //           }
  //         })
  //         .catch(err => console.error(err));
  //     }, 1000);
  //   }

  //   return () => {
  //     if (speech_interval) clearInterval(speech_interval);
  //   };
  // }, []);

  const toast = useToast();
  const registeringToastIdRef = useRef();

  const enrollRequest = () => {
    axios
      .post(`${BASE_URL}/voice/enroll`, {
        stream_uid,
        external_uid: external_id
      },{
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },)
      .then(res => {
        if (res.status === 200) {
          console.log("Enrolled");
          setProgress(0)
          // move forward

          registeringToastIdRef.current = toast({
            title: "Registering Your Voice",
            description:
              "Please wait while we register your voice into our system",
            status: "loading",
            duration: 2000,
            isClosable: true
          });

          axios
            .get(`${BASE_URL}/stream/http/${stream_uid}`,{
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            },)
            .then(res => {
              console.log("Voice Enroll Success", res.data);
              if (res.status === 200) {
                if (registeringToastIdRef.current) {
                  toast.close(registeringToastIdRef.current);
                }

                toast({
                  title: "Successfully Registered Your Voice",
                  status: "success",
                  duration: 3000,
                  isClosable: true
                });
                setSpeechDuration(res.data.speech_duration);
                setCurrentStep("callSummary");
              }
            })
            .catch(err => {
              console.error("Error Closing Stream ", err);
            });
        }
      })
      .catch(err => console.error("Voice Enroll Failed: ", err));
  };

  useEffect(() => {
    console.log("progress----------->",progress)
    if (currentStep === "details" && progress >= 20) {
      if (speech_interval) {
        clearInterval(speech_interval);
        speech_interval = null;
      }
      enrollRequest();
    }
  }, [progress]);

  // Double Check
  const handleEndCall = e => {
    console.log(speech_interval);
    if (speech_interval) {
      clearInterval(speech_interval);
      speech_interval = null;
    }
    enrollRequest();
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -200 }}
        style={{ width: "100%" }}
      >
        <Text fontSize="lg" mt={-4} color="gray.500" textAlign="left">
          Continue speaking till the circle turns green
        </Text>
        <VStack spacing="22px" w="100%" mt={5}>
          <Text fontSize="md" textColor="black">
            Dialing {external_id}
          </Text>
          <CircularProgress
            value={progress * 5}
            color="green.300"
            size="200px"
            thickness="4px"
            alignSelf="center"
            capIsRound
            valueText="xsaa"
          >
            <CircularProgressLabel fontSize="sm">
              <Text>00:{progress}</Text>
              <Text color="gray.400">of speaking</Text>
            </CircularProgressLabel>
          </CircularProgress>
          <Button
            size="lg"
            mt="10"
            w="100%"
            color="white"
            bgColor="black"
            onClick={handleEndCall}
          >
            End Call
          </Button>
        </VStack>
      </motion.div>
    </AnimatePresence>
  );
};

export default CallStart;
